import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as allActions from "./actions";

/**
 * Hook providing bound action creators for the users Redux slice.
 * @returns {Object} Bound action creators: updateUsers, updateUsersSearchForm, updateUserForm, clearUsers, clearUserForm
 */
export function useUsersActions() {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
